import React, { memo } from "react";
import DeliveryHead from "../DeliveryHead";
import { Grid, Container } from "@mui/material";
import MainButton from "../../../shared/Button";
import { useNavigate } from "react-router-dom";
import order_preview_mobile from "../../../../assets/images/order-preview_mobile.png";
import {
  PreviewOrderMain,
  PreviewOrderHeader,
  OrderSteps,
  OrderButtonMain,
} from "../styles/PreviewOrderStyle";

const PreviewOrder = ({ NavigateCallback, StepsCount }) => {
  const navigate = useNavigate();

  const ShowPreviusPage = () => {
    NavigateCallback(false);
  };

  let cirText = "4 of 4";

  if (StepsCount === 2) {
    cirText = "5 of 5";
  } else if (StepsCount === 3) {
    cirText = "6 of 6";
  } else if (StepsCount === 4) {
    cirText = "7 of 7";
  } else if (StepsCount === 5) {
    cirText = "8 of 8";
  }
  return (
    <>
      <DeliveryHead
        Value={100}
        BackLink="/route-order-details"
        CenterText="Preview Order"
        StepText={cirText}
        showBox={true}
        haveCallBack={true}
        CallBackFun={ShowPreviusPage}
      />

      <PreviewOrderMain>
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            <Grid item xs={12} md={10} lg={7}>
              <PreviewOrderHeader>
                <img src={order_preview_mobile} alt="order_preview_mobile" />
                <h6>Your request has been sent.</h6>
                <p>You’ll receive offers shortly.</p>
              </PreviewOrderHeader>
              <OrderSteps>
                <ul>
                  <li>
                    <div className="OrderStepsMian">
                      <div className="OrderStepsText">
                        <h6>First Stop</h6>
                        <p>1213 Washington Blvd, Belpre, OH </p>
                      </div>
                      <div className="OrderStepsButton">
                        <span>Pickup</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="OrderStepsMian">
                      <div className="OrderStepsText">
                        <h6>Second Stop</h6>
                        <p>1213 Washington Blvd, Belpre, OH </p>
                      </div>
                      <div className="OrderStepsButton">
                        <span className="Dropoff">Drop-off</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="OrderStepsMian">
                      <div className="OrderStepsText">
                        <h6>Third Stop</h6>
                        <p>1213 Washington Blvd, Belpre, OH </p>
                      </div>
                      <div className="OrderStepsButton">
                        <span className="Dropoff">Drop-off</span>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div className="OrderStepsMian">
                      <div className="OrderStepsText">
                        <h6>Last Stop</h6>
                        <p>1213 Washington Blvd, Belpre, OH </p>
                      </div>
                      <div className="OrderStepsButton">
                        <span>Pickup</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </OrderSteps>
              <OrderButtonMain>
                <MainButton
                  type="button"
                  label="Cancel Order"
                  border={true}
                  onClick={() => navigate("/delivery-home")}
                />
                <MainButton
                  type="button"
                  label="Back to Home"
                  onClick={() => navigate("/delivery-home")}
                />
              </OrderButtonMain>
            </Grid>
          </Grid>
        </Container>
      </PreviewOrderMain>
    </>
  );
};

export default memo(PreviewOrder);
